export const SET_FAQS = 'SET_FAQS'
export const SET_FAQ = 'SET_FAQ'
